import ImageOverlay from "@/components/image-overlay";

export interface GridCol3Props {
  content: {
    id: string;
    text: string;
    thumbnail: string;
    thumbnail_mobile: string;
    icon: string;
  }[];
}
export default function GridCol3(props: GridCol3Props) {
  return (
    <div className="flex flex-col xl:flex-row">
      {props.content.map((content) => {
        return (
          <div key={content.id} className="relative flex-1">
            <div className="absolute top-11 w-full hidden xl:inline-flex justify-center">
              <img
                src={content.icon}
                loading="lazy"
                alt=""
                className="object-cover w-14 h-14 z-[2]"
              />
            </div>

            <div className="hidden xl:block">
              <ImageOverlay
                src={content.thumbnail}
                alt="hero"
                className="w-full object-cover h-[calc(100vh-var(--navbar-height))]"
              />
            </div>

            <img
              src={content.thumbnail_mobile}
              alt="hero"
              className="w-full object-cover object-top block xl:hidden h-[10rem]"
            />

            <div className="absolute bottom-24 w-full inline-flex xl:justify-center z-[2]">
              <span className="text-sm xl:text-4xl text-white font-pluto  ml-11 xl:ml-0">
                {content.text}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
